import React from 'react';
import { FaRegCircleUser } from 'react-icons/fa6';

interface IProfileMenu {
  auth?: any;
}

export const ProfileMenu: React.FC<IProfileMenu> = ({ auth }: any) => {
  const onLogout = () => {
    window.localStorage.clear();
    window.location.href = './login';
  };

  return (
    <div className='flex flex-col border border-pureWhite/20 backdrop-blur-xl text-textGray rounded-md bg-pureBlack/90 min-w-[14rem]'>
      <div className='flex items-center gap-3 rounded-t-md bg-cardGray/30 py-2 px-4 border-b-2 border-b-pureWhite/10'>
        <FaRegCircleUser className='h-7 w-7 rounded-full text-indigo-900 hover:border-[2px] hover:border-red-400' />

        <div className='text-textGray pr-8'>
          <div className='text-p2 font-bold'>{`${auth?.user?.firstname} ${auth?.user?.lastname}`}</div>
          <div className='text-p3'>{auth?.email || ' '}</div>
        </div>
      </div>
      <div className='text-p2'>
        <div
          className='px-4 py-2 hover:bg-pureWhite/20 cursor-pointer'
          onClick={onLogout}
        >
          <div className='flex gap-2 items-center'>
            <div>Sign Out</div>
          </div>
        </div>
      </div>
    </div>
  );
};
